export function FileTypeBadge({ type }: { type: string }) {
  const label = (type || "file").toUpperCase();
  return (
    <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide bg-[color-mix(in_srgb,var(--association-theme-color-1)_12%,transparent)] text-[var(--association-theme-color-1)]">
      {label}
    </span>
  );
}
